import * as React from "react";
import { withStyles } from "@material-ui/core/styles";
import { WBSStore } from "../../WBSStore";

const styles = (theme) => ({
  btnNext: { color: theme.palette.primary.light },
});

const StarRecalc = (props) => {
  const { classes } = props;

  const recalc = () => {
    WBSStore.loadingTaskChange = true;
    WBSStore.changeDecimalAndRule().then(() => {
      setTimeout(() => {
        WBSStore.loadingTaskChange = false;
        WBSStore.loadingTaskUpload = false;
      }, 1000);
    });
  };
  if (WBSStore.WBS.data.updateCompositions) {
    if (
      WBSStore.WBS.data.updateCompositions.totalCompositions == 0 &&
      WBSStore.WBS.data.updateCompositions.totalCompositions ==
        WBSStore.WBS.data.updateCompositions.count &&
      WBSStore.WBS.data.updateCompositions.isProcessing == false &&
      WBSStore.loadingTaskUpload == true
    ) {
      recalc();
    }
  }
  return <></>;
};

export default withStyles(styles)(StarRecalc);



// WEBPACK FOOTER //
// ./src/modules/WBS/components/layouts/StarRecalc.tsx